export default __webpack_public_path__ + "static/Concept-1-a273d66654dae9d5866725784b1164d9.jpg";